.mobileFiltersModal {
  margin-left: 10%;
  width: 90%;
  position: relative;
  transform: none;
  top: 0;
  left: 0;
}

@media all and (--reefer-media-tablet-min) {
  .mobileFiltersButton {
    display: none;
  }
}
